export const activate_en = {
    load: 'Activate',
    positiveResponse: 'Activation was successful',
    negativeResponse: 'Something went wrong',
    repeatRequest: 'You are already registered',
    linkMainPage: 'Home page',
    login: 'Login',
}